import timeout from 'utils/http/middlewares/timeout';

import type { IHttpConfig } from './httpClient.model';
import base from './middlewares/base';
import fakeSso from './middlewares/fakeSso';
import monitor from './middlewares/monitor';
import queryParams from './middlewares/queryParams';
import redirectTokenExpired from './middlewares/redirectTokenExpired';
import sgConnect from './middlewares/sgConnect';
import { polling, signalr } from './middlewares/streams';

const baseMiddlewareArray = [base, monitor, sgConnect, queryParams, timeout];
if (window?.sgmeConfiguration?.enablePolling) {
  baseMiddlewareArray.push(polling);
}
if (window?.sgmeConfiguration?.enableSignalr) {
  baseMiddlewareArray.push(signalr);
}
if (window?.sgmeConfiguration?.enableFakeSso) {
  baseMiddlewareArray.push(fakeSso);
}

export function useRequestMiddlewares(config: IHttpConfig): IHttpConfig {
  const updatedConfig = baseMiddlewareArray.reduce<IHttpConfig>(
    (currentConfig, middleware) => middleware(currentConfig),
    config,
  );
  return updatedConfig;
}

export const useResponseMiddlewares = () => (response: Response) => {
  const middlewares = [redirectTokenExpired];

  return middlewares.reduce((currentResponse, middleware) => middleware(currentResponse), response);
};
